import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export function RequireAuth({ children }: { children: ReactNode }): JSX.Element {
  const auth = useAuth();
  const loc = useLocation();
  if (auth.status === "loading") return <p>Loading…</p>;
  if (auth.status !== "authed") {
    return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  }
  return <>{children}</>;
}
